/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-tag-input/~/lodash/_baseLodash.js
 ** module id = 1194
 ** module chunks = 0
 **/